
import { BsPostcardHeart } from 'react-icons/bs';
import { get, put, post, del, getResume } from './connection'

// const API_BASE_URL = process.env.REACT_APP_API_URL;
const masterApi = {
    getCountry: async (id) => {
        try {
            return get("/master/get-country/:"+id);
        } catch (error) {
            throw new Error("Error while creating new country");
        }
    },

    createCountry: async (requestData) => {
        try {  
            return post(`/master/add-country`, requestData.formattedData);  
        } catch (error) {
            throw new Error("Error while creating new country");
        }
    },

    updateCountry: async (requestData) => {
        try {
            return put(`/master/edit-country/${requestData.countryId}`, requestData.formattedData);
        } catch (error) {
            throw new Error("Error while creating new stage");
        }
    },

    getAllCountry: async () => {
        try {
            return get(`/master/get-all-country`);
        } catch (error) {

            throw new Error("Error while creating new stage");
        }
    },

    deleteCountry: async (deleteData) => {
        try {
            return del(`master/delete-country/${deleteData.countryId}`);
        } catch (error) {
            throw new Error("Error while creating new country");
        }
    },

    //roles
    getAllRoles: async (queryString) => {
        try {            
            return get(`/master/get-all-roles` + queryString);
        } catch (error) {

            throw new Error("Error while selecting all roles");
        }
    },
    getActiveRoles: async () => {
        try {            
            return get(`/master/get-active-roles`);
        } catch (error) {

            throw new Error("Error while selecting active roles");
        }
    },
    
    createRole: async (requestData) => {
        try {
            return post(`/master/add-role`, requestData);
        } catch (error) {
            throw new Error("Error while creating new role");
        }
    },
    updateRole: async (requestData) => {
        try {
            return put(`/master/edit-role/`+requestData.roleid, requestData);
        } catch (error) {
            throw new Error("Error while creating new role");
        }
    },
    deleteRole: async (requestData) => {
        try {
            return del(`/master/delete-role/`+ requestData);
        } catch (error) {
            throw new Error("Error while deleting  role");
        }
    },
    getActiveDepartments: async () => {
        try {            
            return get(`/master/get-active-departments`);
        } catch (error) {

            throw new Error("Error while selecting all roles");
        }
    },
    
    getActiveProjectAccounts: async () => {
        try {            
            return get(`/master/get-active-projectAccount`);
        } catch (error) {

            throw new Error("Error while selecting all roles");
        }
    },
    getActiveCompanies: async () => {
        try {            
            return get(`/master/get-active-company`);
        } catch (error) {

            throw new Error("Error while selecting active companies");
        }
    },
    getActiveEducationalQualification: async () => {
        try {            
            return get(`/master/get-active-educational-qualification`);
        } catch (error) {

            throw new Error("Error while selecting active educational-qualifications");
        }
    },
    getActiveSkill: async () => {
        try {            
            return get(`/master/get-active-skill`);
        } catch (error) {

            throw new Error("Error while selecting active skills");
        }
    },
    getActiveUsers: async () => {
        try {            
            return get(`/user/get-active-users`);
        } catch (error) {

            throw new Error("Error while selecting active users");
        }
    },
    getAllUsers: async (queryString) => {
        try {            
            return get(`/user/get-all-users`+queryString);
        } catch (error) {

            throw new Error("Error while selecting active skills");
        }
    },
    getActiveEmploymentTypes: async () => {
        try {            
            return get(`/master/get-active-employment-types`);
        } catch (error) {

            throw new Error("Error while selecting active employment types");
        }
    },
    createSkills: async (requestData) => {
        try {            
            return post(`/master/add-skill`,requestData);
        } catch (error) {

            throw new Error("Error while creating skill");
        }
    },
    forgotPassword: async (requestData) => {
        try {
            const response = post(`/auth/forgotPassword`, requestData.data);
           return response;
        } catch (error) {
            throw new Error("Error in forgotpassword api call");
        }
    },
    resetPasswordWithLink: async (requestData) => {
        try {
            const response = post(`/auth/resetPasswordUsingResetLink`, requestData.formData);
           return response;
        } catch (error) {
            throw new Error("Error in forgotpassword api call");
        }
    },
    validateResetPasswordLink: async (requestData) => {
        try {
            const response = post(`/auth/validateResetPasswordLink`, requestData);
           return response;
        } catch (error) {
            throw new Error("Error in validate reset link");
        }
    },
    resetPassword: async (requestData) => {
        try {
            const response = post(`/auth/resetpassword`, requestData.data);
           return response;
        } catch (error) {
            throw new Error("Error while creating new stage");
        }
    },  

    getStatesByCountryId: async (id) => {
        try {            
            return get("/master/get-state-by-country-id/"+id);
        } catch (error) {
            throw new Error("Error while fetching states");
        }
    },

    getActiveCurrenies: async (id) => {
        try {
            return get("/master/get-active-currenies/");
        } catch (error) {
            throw new Error("Error while fetching currencies");
        }
    },
    getCurreniesById: async (id) => {
        try {
            return get("/master/get-currenies/"+id);
        } catch (error) {
            throw new Error("Error while creating new currenies");
        }
    },
    
    createBoard: async (requestData) => {
        try {
            return post(`/master/add-board`, requestData);
        } catch (error) {
            throw new Error("Error while creating new board");
        }
    },
    getActiveBoard: async () => {
        try {
            return get(`/master/get-active-boards`);
        } catch (error) {
            throw new Error("Error while selecting boards");
        }
    },    
    getLookups: async (type) => {
        try {      
            // const A=  await get(`/candidate/get-comments-by-candidateid/${id}`);
            // debugger
            // return A;
            return await get(`/master/lookups/${type}`);
        } catch (error) {
            throw new Error("Error while selecting lookups");
        }
    },

    getcandidateResume: async (id) => {
        try {
            return getResume("/candidate/download-resume/"+id);
        } catch (error) {
            throw new Error("Error while fetching states");
        }
    },
    getBoardById: async (id) => {
        try {
            return get("/master/get-board-by-id/"+id);
        } catch (error) {
            throw new Error("Error while selecting board");
        }
    },
    editBoard: async (requestData) => {
        try {
            return put(`/master/edit-board/`+ requestData.id, requestData);
        } catch (error) {
            throw new Error("Error while creating new board");
        }
    },
    getActiveDesignations: async () => {
        try {
            return get(`/master/get-active-designations`);
        } catch (error) {
            throw new Error("Error while selecting designations");
        }
    }, 
    createUser: async (requestData) => {
        try {
            return await post(`/user/add-user`, requestData);
        } catch (error) {
            throw new Error("Error while creating new user");
        }
    },
    editUser: async (requestData) => {
        try {
            return put(`/user/edit-user/`+ requestData.id, requestData);
        } catch (error) {
            throw new Error("Error while updating  new user");
        }
    },
    deleteUser: async (id) => {
        try {
            return del(`/user/delete-user/`+ id);
        } catch (error) {
            throw new Error("Error while updating  new user");
        }
    },
    getUserById:  async (id) => {
        try {
            return get(`/user/get-user/`+id);
        } catch (error) {
            throw new Error("Error while selecting user");
        }
    },
    getRoleFunctionalities:async(roleid)=>{
        try {
            // debugger;
            return get(`/master/get-role-functionalities/`+ roleid);
        } catch (error) {
            throw new Error("Error while selecting role functionalities");
        } 
    },
    createOrUpdateRoleMappings: async (requestData) => {
        try {
            return post(`/master/create-or-update-role-functionality-mappings`, requestData);
        } catch (error) {
            throw new Error("Error while creating new role");
        }
    },
    getRoleById:async(roleid)=>{
        try {
            return get(`/master/get-role-byid/`+ roleid);
        } catch (error) {
            throw new Error("Error while selecting role");
        } 
    },
    createCompanyFromApi: async (companies) => {
        try {
            return post(`/master/add-company-from-api`, companies);
        } catch (error) {
            throw new Error("Error while creating new companies");
        }
    },
    createCountryFromApi: async (countries) => {
        try {  
            return post(`/master/add-country-from-api`, countries);  
        } catch (error) {
            throw new Error("Error while creating new country");
        }
    },
    createDepartmentFromApi: async (departments) => {
        try {  
            return post(`/master/add-department-from-api`, departments);  
        } catch (error) {
            throw new Error("Error while creating new department");
        }
    },
    createDesignationFromApi: async (designations) => {
        try {  
            return post(`/master/add-designation-from-api`, designations);  
        } catch (error) {
            throw new Error("Error while creating new designation");
        }
    },
    createStateFromApi: async (states) => {
        try {  
            return post(`/master/add-state-from-api`, states);  
        } catch (error) {
            throw new Error("Error while creating new state");
        }
    },
    sendNotificationMail: async (requestData) => {
        try {
            return post(`/auth/send-notification-mail`, requestData);
        } catch (error) {
            throw new Error("Error while sending notification mail");
        }
    },
    getActiveTags: async () => {
        try {            
            return get(`/master/get-active-tags`);
        } catch (error) {

            throw new Error("Error while selecting active tags");
        }
    },
    saveAccountDetailsFromTimeZone: async (accountData) => {
        console.log("accountData", accountData);
        try {  
            return post(`/master/add-projectAccount`, accountData);  
        } catch (error) {
            throw new Error("Error while creating new account");
        }
    },

    getActiveLoactions: async () => {
        try {            
            return get(`/master/get-active-locations`);
        } catch (error) {

            throw new Error("Error while selecting active locations");
        }
    },


    getNotifications: async () => {
    try {
        return get(`/user/get-notifications`);
    } catch (error) {
        throw new Error("Error while fetching notifications");
    }
   },

   markNotificationsRead: async () => {
    debugger
    try {
        return post(`/user/mark-notifications-read`);
    } catch (error) {
        throw new Error("Error while marking notifications as read");
    }
    },
    
    
};

export default masterApi;